import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

export const business = {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/business/index.js